import React, { useState } from 'react';
import { MdContentCopy, MdOutlineCall } from 'react-icons/md';
import { IoClose } from 'react-icons/io5';
import Button from '../Button/Button';
import { useCopyToClipboard } from '../../hooks/useCopyToClipboard';
import { trackEvent } from '../../utils/googleAnalytics';
import { EVENTS_MAP } from '../../config/g4a/analytics-map';
import styles from './ContactDialog.module.css';

const PHONE_NUMBER = '+48 794 601 866';
const CLOSE_ANIMATION_MS = 300;

const ContactDialog: React.FC = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const { copy, copied } = useCopyToClipboard();

  const toggleDialog = () => {
    if (isDialogOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setIsDialogOpen(false);
        setIsClosing(false);
      }, CLOSE_ANIMATION_MS);
    } else {
      setIsDialogOpen(true);
      trackEvent(EVENTS_MAP.PHONE_DIALOG_OPEN);
    }
  };

  const callPhoneNumber = () => {
    trackEvent(EVENTS_MAP.PHONE_DIALOG_CALL);
    window.location.href = `tel:${PHONE_NUMBER}`;
  };

  if (typeof window !== 'undefined') {
    (window as any).toggleDialog = toggleDialog;
  }

  return (
    <>
      {(isDialogOpen || isClosing) && (
        <div
          className={`${styles.overlay} ${isClosing ? styles.fadeOut : ''}`}
          onClick={toggleDialog}
        />
      )}
      <button className={styles.floatingButton} onClick={toggleDialog}>
        {isDialogOpen ? <IoClose size={28} /> : <MdOutlineCall size={28} />}
      </button>
      {(isDialogOpen || isClosing) && (
        <div className={`${styles.dialog} ${isClosing ? styles.slideDown : ''}`}>
          <div className={styles.dialogTitle}>Kontakt telefoniczny</div>
          <div className={styles.dialogSubtitle}>
            <p>Opowiedz o swoim projekcie.</p>
          </div>
          <button
            className={styles.phoneNumber}
            onClick={() => {
              trackEvent(EVENTS_MAP.PHONE_DIALOG_COPY);
              copy(PHONE_NUMBER);
            }}
          >
            <span>{PHONE_NUMBER}</span>
            <MdContentCopy size={20} className={styles.copyIcon} />
          </button>
          <Button variant={'primary'} onClick={callPhoneNumber} className={styles.callButton}>
            <b>Zadzwoń teraz</b> <MdOutlineCall size={18} />
          </Button>
        </div>
      )}
      {copied && <div className={styles.snackbar}>Numer telefonu skopiowany do schowka!</div>}
    </>
  );
};

export default ContactDialog;
